import { apiUrl } from "config/runtimeConfig";

const URL = apiUrl;

const AUTH_ENDPOINT = "api/auth";
const EMPLEADOS_ENDPOINT=`api/v2/empleados`;
const EMPRESAS_ENDPOINT = `api/v1/empresas`;
const DEPARTAMENTOS_ENDPOINT=`api/v2/departamentos`;
const CENTROS_ENDPOINT=`api/v2/centros`;
const AUSENCIAS_ENDPOINT=`api/v1/ausencias`;
const EXPORTACIONES_ENDPOINT=`api/v1/pdf`;
const FESTIVOS_ENDPOINT=`api/v1/festivos`;
const FICHAJES_ENDPOINT=`api/v2/fichajes`;
const HORARIOS_ENDPOINT=`api/v2/horarios`;
const INCIDENCIAS_ENDPOINT=`api/v1/incidencias`;
const MOTIVOS_ENDPOINT=`api/v1/motivos`;
const SOLiCITUDES_ENDPOINT=`api/v1/solicitudes`;
const SOLiCITUDES_AUSENCIA_ENDPOINT=`api/v2/solicitudes`;
const NOTIFICACIONES_ENDPOINT=`api/v2/notificaciones`;
const INFORMES_PERIODICOS_ENDPOINT = `api/v2/informes-periodicos`;

const API_ENDPOINTS ={
    EMPLEADO: {
        ALL: (idEmpresa, page, size) => `${URL}/${EMPLEADOS_ENDPOINT}?empresa=${idEmpresa}&page=${page}&size=${size}`,
        ALL_BY_DEPARTAMENTO:(idDepartamento, page, size) => `${URL}/${EMPLEADOS_ENDPOINT}/departamento/${idDepartamento}?page=${page}&size=${size}`,
        CREATE: `${URL}/${EMPLEADOS_ENDPOINT}`,
        ONE:(idEmpresa, idEmpleado) => `${URL}/${EMPLEADOS_ENDPOINT}/${idEmpresa}/${idEmpleado}`,
        UPDATE_ONE:(idEmpleado) => `${URL}/${EMPLEADOS_ENDPOINT}/${idEmpleado}`,
        UPDATE_HORARIO: (idEmpresa, idEmpleado)=> `${URL}/${EMPLEADOS_ENDPOINT}/${idEmpresa}/${idEmpleado}/horario`,
        UPDATE_PASSWORD:(idEmpleado)=> `${URL}/${EMPLEADOS_ENDPOINT}/password/${idEmpleado}`,
    },
    EMPRESA: {
        ONE: (idEmpresa) => `${URL}/${EMPRESAS_ENDPOINT}/${idEmpresa}`,
        UPDATE: (idEmpresa) => `${URL}/${EMPRESAS_ENDPOINT}/${idEmpresa}`,
    },
    DEPARTAMENTO:{
        ONE: (idDepartamento) => `${URL}/${DEPARTAMENTOS_ENDPOINT}/${idDepartamento}`,
        ALL: (idEmpresa, page, size) => `${URL}/${DEPARTAMENTOS_ENDPOINT}/empresa/${idEmpresa}?page=${page}&size=${size}`,
        CREATE: `${URL}/${DEPARTAMENTOS_ENDPOINT}`,
    },
    CENTRO: {
        ONE: (idCentro)  => `${URL}/${CENTROS_ENDPOINT}/${idCentro}`,
        ALL:   (idEmpresa) =>`${URL}/${CENTROS_ENDPOINT}/empresa/${idEmpresa}?page=0&size=1000`,
        ALL_PAGEABLE: (idEmpresa, page, size) => `${URL}/${CENTROS_ENDPOINT}/empresa/${idEmpresa}?page=${page}&size=${size}`,
        CREATE: `${URL}/${CENTROS_ENDPOINT}`,
    },
    AUSENCIA:{
        ONE: (idAusencia) => `${URL}/${AUSENCIAS_ENDPOINT}/${idAusencia}`,
        COMPUTO: (idEmpleado, anno) =>`${URL}/${AUSENCIAS_ENDPOINT}/empleado/${idEmpleado}/computo?anno=${anno}`,
        INCIDENCIAS_VACACIONES:(idEmpresa, anno) =>`${URL}/${AUSENCIAS_ENDPOINT}/recuentoVacaciones/${idEmpresa}?year=${anno}`,
        INCIDENCIAS_DEPARTAMENTO:(idEmpresa, anno) =>`${URL}/${AUSENCIAS_ENDPOINT}/incidenciasDepartamento/${idEmpresa}?year=${anno}`,
        ALL_BY_ANNO_MES_AND_EMPLEADO_ID:(anno, mes, empleadoId) =>`${URL}/${AUSENCIAS_ENDPOINT}/empleado/${empleadoId}?anno=${anno}&mes=${mes}`,
        CREATE: `${URL}/${AUSENCIAS_ENDPOINT}`,
        CREATE_DESDE_HASTA: `${URL}/${AUSENCIAS_ENDPOINT}/desde-hasta`,
        COUNT_AUSENCIAS_MOTIVO_IN_YEAR: (empleadoId, year)=> `${URL}/${AUSENCIAS_ENDPOINT}/recuentoMotivosAusencia?empleado=${empleadoId}&year=${year}`,
    },
    EXPORTACION:{
        FICHAJES_BY_DATE: (empresa, desde, hasta, departamentoId)  =>`${URL}/${EXPORTACIONES_ENDPOINT}/${empresa}/simplificado?desde=${desde}&hasta=${hasta}${departamentoId!=="Todos" ? `&departamento=${departamentoId}`:""}`,
        FICHAJES_DETALLADOS: (empresa, desde, hasta, departamentoId, hasFirma) => `${URL}/${EXPORTACIONES_ENDPOINT}/${empresa}/informe-detallado?desde=${desde}&hasta=${hasta}${departamentoId!=="Todos" ? `&departamento=${departamentoId}`:""}&firma=${hasFirma}`,
        FICHA_EMPLEADO: (empresa, empleadoId, anno) =>`${URL}/${EXPORTACIONES_ENDPOINT}/${empresa}/ficha/${empleadoId}/${anno}`,
        FICHA_HORARIO: (empresa, empleadoId, anno) =>`${URL}/${EXPORTACIONES_ENDPOINT}/${empresa}/fichaHorario/${empleadoId}/${anno}` ,
        FICHA_CALENDARIO: (empresa, empleadoId, anno) => `${URL}/${EXPORTACIONES_ENDPOINT}/${empresa}/fichaCalendario/${empleadoId}/${anno}`,
        HORAS_EXTRA: (empresa, departamentoId, anno)=> `${URL}/${EXPORTACIONES_ENDPOINT}/${empresa}/horas?anno=${anno}${departamentoId!=="Todos" ? `&departamento=${departamentoId}`:""}`,
        HORAS_EXTRA_MES: (empresa, anno, mes, departamentoId, centroId) => {
            let params = `?anno=${anno}`;
            if (mes !== null && mes !== "" && mes !== "Todos") {
                params += `&mes=${mes}`;
            }
            if (departamentoId !== null && departamentoId !== "" && departamentoId !== "Todos") {
                params += `&departamento=${departamentoId}`;
            }
            if (centroId !== null && centroId !== "" && centroId !== "Todos") {
                params += `&centro=${centroId}`;
            }
            return `${URL}/${EXPORTACIONES_ENDPOINT}/${empresa}/horas-extra-mes${params}`;
        },
        LOPD:(empresa, empleadoId) => `${URL}/${EXPORTACIONES_ENDPOINT}/${empresa}/lopd/${empleadoId}`,
        INFORME_FICHAJES: (empresaId, params) =>  `${URL}/${EXPORTACIONES_ENDPOINT}/${empresaId}/informe-fichajes/empleados${params}`,
        INFORME_FICHAJES_COMPLETO: (empresaId, params) => `${URL}/${EXPORTACIONES_ENDPOINT}/${empresaId}/informe-fichajes-completo/empleados${params}`,
        INFORME_TRAZABILIDAD_FICHAJES: (empresaId, params) => `${URL}/${EXPORTACIONES_ENDPOINT}/${empresaId}/informe-trazabilidad-fichajes${params}`,
    },
    FESTIVOS:{
        ALL: (anno, mes, centroId) => `${URL}/${FESTIVOS_ENDPOINT}/centro/${centroId}?anno=${anno}&mes=${mes}`,
        ALL_BY_ANNO: (anno, centroId) => `${URL}/${FESTIVOS_ENDPOINT}/centro/${centroId}/anno/${anno}`,
        DELETE: (id) =>`${URL}/${FESTIVOS_ENDPOINT}/${id}`,
        CREATE: `${URL}/${FESTIVOS_ENDPOINT}`
    },
        FICHAJES:{
        CREATE_MANUAL: () => `${URL}/${FICHAJES_ENDPOINT}/manual`,
        CREATE: `${URL}/${FICHAJES_ENDPOINT}`,
        DELETE: (id) =>`${URL}/${FICHAJES_ENDPOINT}/${id}`,
        ONE: (id)=>`${URL}/${FICHAJES_ENDPOINT}/${id} `,
        ALL_BY_DATES: (empresaId, empleadoId, desde, hasta, estado = "ACTIVOS", page = 0, size = 10) =>  `${URL}/${FICHAJES_ENDPOINT}?empresaId=${empresaId}&empleadoId=${empleadoId}&desde=${desde}&hasta=${hasta}&estado=${estado}&page=${page}&size=${size}`,
        ALL_BY_EMPRESA_AND_DATES: (empresaId, desde, hasta, estado = "ACTIVOS", page = 0, size = 10) => `${URL}/${FICHAJES_ENDPOINT}?empresaId=${empresaId}&desde=${desde}&hasta=${hasta}&estado=${estado}&page=${page}&size=${size}`,
        ALL_BY_DATES_RANGE: (empresaId, empleadoId, desde, hasta, estado = "ACTIVOS", page = 0, size = 10) => `${URL}/${FICHAJES_ENDPOINT}?empresaId=${empresaId}&empleadoId=${empleadoId}&desde=${desde}&hasta=${hasta}&estado=${estado}&page=${page}&size=${size}`,
    },
    HORARIOS:{
        CREATE: `${URL}/${HORARIOS_ENDPOINT}`,
        UPDATE:(idEmpresa, idHorario) => `${URL}/${HORARIOS_ENDPOINT}/${idEmpresa}/${idHorario}`,
        DELETE:(idHorario)=> `${URL}/${HORARIOS_ENDPOINT}/${idHorario}`,
        ONE: (id) => `${URL}/${HORARIOS_ENDPOINT}/${id}`,
        GET_ALL: (idEmpresa, page, size)=> `${URL}/${HORARIOS_ENDPOINT}/empresa/${idEmpresa}?page=${page}&size=${size}`
    },
    INCIDENCIAS:{
        CREATE: `${URL}/${INCIDENCIAS_ENDPOINT}`,
        ALL:(empleadoId) => `${URL}/${INCIDENCIAS_ENDPOINT}/${empleadoId}`,
        DELETE:(permisoId) => `${URL}/${INCIDENCIAS_ENDPOINT}/${permisoId}`
    }
    ,
    LOGIN:{
        EMPRESA: `${URL}/${AUTH_ENDPOINT}/login`,
        EMPLEADO: `${URL}/${AUTH_ENDPOINT}/login`,
        UPDATE_PASSWORD: (UserID) => `${URL}/${AUTH_ENDPOINT}/password/${UserID}`,
        VALIDAR: `${URL}/${EMPLEADOS_ENDPOINT}/validateToken`,
        EMPRESA_ID: (nombreEmpresa) => `${URL}/${EMPRESAS_ENDPOINT}/${nombreEmpresa}`,
        USER_ID: (empresaNombre, usuario) => `${URL}/${EMPLEADOS_ENDPOINT}/${empresaNombre}/${usuario}/id`,
    },
    MOTIVOS:{
        ALL: (empresaId) => `${URL}/${MOTIVOS_ENDPOINT}/${empresaId}`,
        CREATE: (empresaId) => `${URL}/${MOTIVOS_ENDPOINT}/${empresaId}`,
        UPDATE: (empresaId) => `${URL}/${MOTIVOS_ENDPOINT}/${empresaId}`,
        DELETE: (empresaId) => `${URL}/${MOTIVOS_ENDPOINT}/${empresaId}`,
    }
    ,
    SOLICITUDES:{
        ALL:(idEmpresa, page, size) => `${URL}/${SOLiCITUDES_ENDPOINT}/empresa/${idEmpresa}?page=${page}&size=${size}`,
        ALL_BY_EMPLEADOID_DESDE_HASTA_ESTADO: (idEmpleado, desde, hasta, estado) =>`${URL}/${SOLiCITUDES_ENDPOINT}/empleado/${idEmpleado}?desde=${desde}&hasta=${hasta}&estado=${estado}`,
        ALL_BY_EMPLEADOID: (idEmpleado) => `${URL}/${SOLiCITUDES_ENDPOINT}/empleado/${idEmpleado}`,
        ALL_PENDIENTES: (idEmpleado) => `${URL}/${SOLiCITUDES_ENDPOINT}/empleado/${idEmpleado}?estado=PENDIENTE` ,
        ALL_NOTIFICACIONES_EMPRESA : (idEmpresa) => `${URL}/${SOLiCITUDES_ENDPOINT}/empresa/${idEmpresa}`,       
        DELETE : (idHorario) => `${URL}/${SOLiCITUDES_ENDPOINT}/${idHorario}`,
        CREATE_BY_EMPLEADOID : (idEmpleado) => `${URL}/${SOLiCITUDES_ENDPOINT}/empleado/${idEmpleado}/solicitud` ,
        TRAMITAR : (idEmpleado, estado) => `${URL}/${SOLiCITUDES_ENDPOINT}/empleado/${idEmpleado}/tramitar/${estado}`
    },
    SOLICITUDES_AUSENCIA:{
        ALL_EMPRESA: (empresaId) => `${URL}/${SOLiCITUDES_AUSENCIA_ENDPOINT}/${empresaId}`,
        ALL_EMPLEADO:(empleadoId) => `${URL}/${SOLiCITUDES_AUSENCIA_ENDPOINT}/empleado/${empleadoId}`,
        CREATE: (empresaId) => `${URL}/${SOLiCITUDES_AUSENCIA_ENDPOINT}/${empresaId}`,
        CALCULAR: (empresaId) => `${URL}/${SOLiCITUDES_AUSENCIA_ENDPOINT}/${empresaId}/calcular`,
        DELETE: (id) => `${URL}/${SOLiCITUDES_AUSENCIA_ENDPOINT}/${id}`,
        NOTIFCICACIONES: (id) => `${URL}/${SOLiCITUDES_AUSENCIA_ENDPOINT}/notificaciones/${id}`,
        TRAMITAR: (id) => `${URL}/${SOLiCITUDES_AUSENCIA_ENDPOINT}/${id}`,
    },
    NOTIFICACIONES: {
        ALL_EMPRESA: (empresaId) => `${URL}/${NOTIFICACIONES_ENDPOINT}/${empresaId}`,
        MARCAR_LEIDA: (empresaId, notificacionId) => `${URL}/${NOTIFICACIONES_ENDPOINT}/${empresaId}/${notificacionId}/leida`,
        DELETE: (empresaId, notificacionId) => `${URL}/${NOTIFICACIONES_ENDPOINT}/${empresaId}/${notificacionId}`,
    },
    INFORMES_PERIODICOS: {
        BY_EMPRESA: (empresaId) => `${URL}/${INFORMES_PERIODICOS_ENDPOINT}/empresa/${empresaId}`,
        CREATE: `${URL}/${INFORMES_PERIODICOS_ENDPOINT}`,
        DELETE: (id) => `${URL}/${INFORMES_PERIODICOS_ENDPOINT}/${id}`,
    }
}
export default API_ENDPOINTS;
